import { useState } from 'react';
import FaqSection from './FaqSection';
import Topbar from './Topbar';
import HeroSection from './HeroSection';
import PricingSection from './PricingSection';
import TestimonialsSection from './TestimonialsSection';
import ContactSection from './ContactSection';
import './App.css';

// Helper to format duration display
const formatDuration = (duration) => {
  if (duration === 1) return '1 Month';
  if (duration === 3) return '3 Months';
  return `${duration} Months`;
};

function App() {
  const [selectedValue, setSelectedValue] = useState(3);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [selectedPlanName, setSelectedPlanName] = useState(() => {
    // Initialize based on selectedValue
    return `${formatDuration(3)}`;
  });

  const handleToggleNav = (value) => {
        if (typeof value === 'boolean') {
          setIsNavOpen(value);
        } else {
          setIsNavOpen((open) => !open);
        }
  };

  return (
    <div className="page">
      <Topbar isNavOpen={isNavOpen} onToggleNav={handleToggleNav} />

      <main>
        <HeroSection />
        <PricingSection
          selectedValue={selectedValue}
          selectedPlanName={selectedPlanName}
          onChangePlan={(value, planName, duration) => {
            setSelectedValue(value);
            if (planName && duration !== undefined && duration !== null) {
              const durationText = typeof duration === 'number' 
                ? (duration === 1 ? '1 Month' : `${duration} Months`)
                : duration;
              setSelectedPlanName(`${durationText}`);
            } else if (planName) {
              setSelectedPlanName(planName);
            } else {
              // Fallback based on value
              if (value === 1) {
                setSelectedPlanName('1 Month');
              } else {
                setSelectedPlanName(`${value} Months`);
              }
            }
          }}
        />
        <TestimonialsSection />
        <ContactSection selectedPlanName={selectedPlanName} selectedValue={selectedValue} />
        <FaqSection />
      </main>
    </div>
  );
}

export default App;
